import { TrackersHook } from '../../../modals/trackerModal/hooks/useTrackers'

export const getTrackerColorForValue = (trackers: TrackersHook, value: number): string => {
    if (!trackers.data || trackers.data.length === 0 || trackers.isLoading || trackers.isFetching) {
        return '#5c95ff'
    }
    return trackers.data.reduce((currentColor, tracker) => {
        if (value < tracker.value) {
            if (tracker.limitType === 'veryLow') {
                return '#127d27'
            }
            if (tracker.limitType === 'low' && currentColor === '#5c95ff') {
                return '#52ae32'
            }
        } else if (value > tracker.value) {
            if (tracker.limitType === 'veryHigh') {
                return '#b21672'
            }
            if (tracker.limitType === 'high' && currentColor === '#5c95ff') {
                return '#ffc13e'
            }
        }
        return currentColor
    }, '#5c95ff')
}
